// removed by extract-text-webpack-plugin
module.exports = {"root":"_36re9","item":"_1kW4c"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Breadcrumb/Breadcrumb.scss
// module id = 1131
// module chunks = 1